import React, { useState, useEffect } from "react"
import { USDottruck, Edit } from "../../images/"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../components/BottomBar/bottombar"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import AlertIcon from "components/AlertIcon/alertIcon"
import { useDispatch, useSelector } from "react-redux"
import "./KioskUSDOT.css"
import { RootState } from "store/store"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import { toast } from "react-toastify"
import { Trans, useTranslation } from "react-i18next"
import i18next from "i18next"

const KioskUSDOT = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [invalidPhone, setinvalidPhone] = useState(false)
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [disabledPhone, setdisabledPhone] = useState(false)
  const [LoadReferenceNumber, setLoadReferenceNumber] = useState("")
  const [USDOT, setUSDOT] = useState("")
  const [companyName, setcompanyName] = useState("")
  const [visitId, setVisitId] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isProceed, setIsProceed] = useState(false)
  const dispatch = useDispatch()

  const appointmentReducer = useSelector(
    (state: RootState) => state.appointmentReducer
  )
  const visitReducer = useSelector((state: RootState) => state.visitReducer)
  const assetReducer = useSelector((state: RootState) => state.assetReducer)

  useEffect(() => {
    setVisitId(visitReducer.visit.id)
    setcompanyName(
      appointmentReducer.appointment.details[0].equipment.carrier.name
    )
    setIsProceed(true)
  }, [])

  const setCompanyDetails = () => {
    let asset = {
      ...assetReducer.asset,
      usdot: USDOT,
      companyName: companyName
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    let companyDetails: any = {}
    if (USDOT) {
      companyDetails["usdot"] = USDOT
    }
    if (companyName) {
      companyDetails["name"] = companyName
    }

    http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: "company-details-submitted",
          mode: "kiosk",
          details: {
            companyDetails: companyDetails
          }
        },
        {}
      )
      .then(res => {
        history.push("/kiosk-tractor-info")
      })
      .catch(err => toast.error(err.response.data.error))
  }

  const handlePaste = (e: any, limit: number, elementName: string) => {
    if (elementName == "companyName") {
      let trunc = companyName.substring(0, limit)
      setcompanyName(trunc)
    }
    if (elementName == "USDOT") {
      let truncUSDOT = USDOT.substring(0, limit)
      setUSDOT(truncUSDOT)
    }
  }

  useEffect(() => {
    if (
      isProceed ||
      (USDOT.trim().length > 0 && companyName.trim().length > 0)
    ) {
      setdisabledProceed(false)
    } else {
      setdisabledProceed(true)
    }
  })

  const onClickEdit = () => {
    setIsEdit(true)
    setIsProceed(false)
  }

  // Here used "carrier name" for display purposes and "company name" to process in the code
  // Both names refer same

  const trans = (key: string) => {
    return i18next.t(key) || ""
  }

  return (
    <>
      <div className="container">
        <div className="header-text">
          {companyName && !isEdit ? (
            <>
              <Trans
                i18nKey="validate_your_carrier_name"
                components={{ newLine: <br /> }}
              />{" "}
            </>
          ) : (
            ""
          )}

          {companyName && isEdit ? (
            <>
              {" "}
              <Trans
                i18nKey="enter_your_usdot_number_and_carrier_name"
                components={{ newLine: <br /> }}
              />{" "}
            </>
          ) : (
            ""
          )}

          {!companyName && isEdit && (
            <>
              {" "}
              <Trans
                i18nKey="enter_your_usdot_number_and_carrier_name"
                components={{ newLine: <br /> }}
              />
            </>
          )}
        </div>
        <div style={{ display: "flex", width: "65%" }}>
          <div style={{ width: "100%" }}>
            {!companyName || isEdit ? (
              <div
                className={` driver-input driver-input-USDOT-font ${
                  invalidPhone ? "error-label" : ""
                }`}
              >
                <Input
                  autoFocus={true}
                  className={`${invalidPhone ? "error-label" : ""}`}
                  placeholder={trans("enter_usdot_here")}
                  label={trans("usdot_number")}
                  defaultValue={USDOT}
                  disabled={disabledPhone}
                  hideLabel={false}
                  name="usdot"
                  maxLength={20}
                  onChange={event => setUSDOT(event.target.value)}
                  onPaste={e => handlePaste(e, 20, "USDOT")}
                  invalid={invalidPhone}
                  errorLabel={
                    invalidPhone ? trans("usdot_number_not_valid") : ""
                  }
                  icon={
                    invalidPhone ? (
                      <AlertIcon className="elemental-Input-icon--invalid" />
                    ) : (
                      <></>
                    )
                  }
                />
              </div>
            ) : (
              ""
            )}
            <div
              className={`driver-input driver-input-usdot driver-input-USDOT-font${
                invalidPhone ? "error-label" : ""
              }`}
            >
              <Input
                className={`${invalidPhone ? "error-label" : ""}`}
                placeholder={trans("enter_your_carrier_name_here")}
                label={trans("carrier_name")}
                defaultValue={companyName}
                onPaste={e => handlePaste(e, 50, "companyName")}
                disabled={disabledPhone}
                maxLength={50}
                readOnly={!isEdit}
                onChange={event => setcompanyName(event.target.value)}
                invalid={invalidPhone}
                errorLabel={invalidPhone ? trans("company_not_valid") : ""}
                icon={
                  invalidPhone ? (
                    <AlertIcon className="elemental-Input-icon--invalid" />
                  ) : companyName && !isEdit ? (
                    <img src={Edit} className="edit" onClick={onClickEdit} />
                  ) : (
                    <></>
                  )
                }
              />
            </div>
          </div>

          <div style={{ margin: "auto" }}>
            <img src={USDottruck} />
          </div>
        </div>
      </div>
      <BottomBar
        disabled={disabledProceed}
        onClick={() => setCompanyDetails()}
        text={t(isEdit ? "looks_good_continue" : "continue")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}
export default KioskUSDOT
